import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  position: relative;
  background-color: ${(props) => props.backgroundColor};
  margin: 0px auto 13px auto;
  ${(props) => props.scale? `transform: scale(${props.scale});`: null};
  
  @media only screen and (min-width: 1200px) {
    ${
      ({ desktop }) => (desktop? `
        top: 140px;
        transform: scale(2);
      `: null)
    };
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    ${
      ({ desktop }) => (desktop? `
        top: 140px;
        transform: scale(2);
      `: null)
    };
  }

  @media only screen and (min-width: 501px) and (max-width: 767px) {
    ${
      ({ desktop }) => (desktop? `
        top: 65px;
        transform: scale(1.5);
      `: null)
    };
  }

  @media only screen and (max-width: 500px) {
    ${
      ({ desktop }) => (desktop? `
        top: 30px;
        transform: scale(1.2);
      `: null)
    };
  }

  .top{
    display: flex;
  }

  .middle {
    display: flex;

    .left {
      display: flex;
      flex-direction: column;
    }

    .right {
      display: flex;
      flex-direction: column;
    }
  }

  .bottom {
    display: flex;
    align-items: flex-end;
  }
`;

export const FloorImageCenterContent = styled.div`
  padding: 16px;
  width: 211px;
  height: 138px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .innerLeft {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    top: 24px;
  }

  .innerCenter {
    position: relative;
  }

  .innerRight {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    top: 24px;
  }
`;

export const EighthFloorInnerLeftBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 4px;
  width: 56px;
  top: 18px;
  right: 0px;
  
  .saunaRoomContainer {
    position: relative;
    display: flex;
    justify-content: center;
    left: 2px;
    height: 26px;

    .room8_44, .room8_45 {
      min-width: 24px;
      max-width: 24px;
    }
  }

  .maleLockerRoom {
    position: relative;
    width: 52px;
    margin: 0 auto;
  }

  .gym {
    position: relative;
    width: 52px;
    margin: 0 auto;
  }
`;

export const EighthFloorInnerCenterBox = styled.div`
  position: relative;
  top: -19px;
  left: -2px;
  width: 56px;

  .row1 {
    .room8_00 {
      margin-left: 28px;
    }
  }

  .row2 {
    width: 100%;
    height: 28px;
    background-color: ${colors.silver};
    margin: 4px 0;
    ::before {
      content: '';
      position: absolute;
      left: 0;
      top: 2px;
      width: 24px;
      height: 47px;
      background-color: ${colors.silver};
    }
  }

  .row3 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 27px;
    background-color: ${colors.silver};
  }
`;

export const EighthFloorInnerRightBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 52px;
  row-gap: 4px;
  
  .saunaRoomContainer {
    position: relative;
    display: flex;
    justify-content: center;
    left: 2px;
    height: 39px;

    .room8_42, .room8_43 {
      min-width: 22px;
      max-width: 22px;
    }
  }

  .femaleLockerRoom {
    width: 48px;
    height: 76px;
    margin: 0 auto;
  }
`;

export const EighthFloorInnerBottomBox = styled.div`
  position: relative;
  top: -4px;
  left: 75px;
`;

export const CenterBoxContainer = styled.div`
  position: relative;
  display: flex;
  width: 56px;
  top: 3px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .row1 {
    .room9_37 {
      margin-left: 30px;
    }
  }

  .row2 {
    width: 100%;
    height: 28px;
    background-color: ${colors.silver};
    margin: 2px 0;
    ::before {
      content: '';
      position: absolute;
      left: 0;
      top: 2px;
      width: 24px;
      height: 47px;
      background-color: ${colors.silver};
    }
  }

  .row3 {
    width: 100%;
    height: 28px;
    background-color: ${colors.silver};
    margin: 2px 0;
  }

  .row4 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 27px;
    background-color: ${colors.silver};
    margin: 2px;
  }

  .row5 {
    position: relative;
    top: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 18px;
  }
`;